import type { DashboardMode } from "@nexus/contracts";
import { withSnapshotDates } from "./explore-date-presets";
import { filtersKey } from "./filters";
import type { CompetitorFilters, MyBrandFilters } from "../types/dashboard.types";

/**
 * Saved globals include products / industryProducts; the explore URL does not.
 * Matching must follow the payload, not the URL serializer.
 */
export function presetGlobalMatches(
  mode: DashboardMode,
  live: {
    competitorFilters: CompetitorFilters;
    myBrandFilters: MyBrandFilters;
  },
  saved: CompetitorFilters | MyBrandFilters,
): boolean {
  const wanted = withSnapshotDates(saved);
  const actual = withSnapshotDates(
    mode === "my-brand" ? live.myBrandFilters : live.competitorFilters,
  );
  return filtersKey(actual) === filtersKey(wanted);
}
